import React, { useEffect, useState } from 'react'
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useParams } from "react-router-dom";
import parse from 'react-html-parser';
// import { OndemandContainer } from '../../MainEvents/styles';
import { QuizContainer } from './styles';
import SkeletonLoder from '../../common/skeletonLoder';
import { GetWellnessChallengeDetails, GetWellnessChallengeResult } from '../../../redux/constants/apiConstants';
import { fetchApi } from '../../../utils/methods';

const QuizDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [challengeDetails, setChallengeDetails] = useState(null);
  const [quizData, setQuizData] = useState([]);

  window.console.log("challengeDetails", challengeDetails)


  useEffect(() => {
    fetchwellnesssChallengeDetails();
    fetchwellnesssChallengeQuizResult();
  }, []);


  const fetchwellnesssChallengeDetails = async () => {
    setLoading(true);
    try {
      const res = await fetchApi(GetWellnessChallengeDetails + '/' + id);
      if (res.status === 'success') {
        setChallengeDetails(res?.data)
        setLoading(false);
      } else {
        toast.error(res?.data?.message);
        setLoading(false);
      }
    } catch (error) {
      window.console.log("error", error);
      setLoading(false);
    }
  }

  const fetchwellnesssChallengeQuizResult = async () => {
    setLoading(true);
    try {
      const res = await fetchApi(GetWellnessChallengeResult + '/' + id);
      if (res.status === 'success') {
        setQuizData(res?.data)
        setLoading(false);
      } else {
        toast.error(res?.data?.message);
        setLoading(false);
      }
    } catch (error) {
      window.console.log("error", error);
      setLoading(false);
    }
  }


  const activeChallengeDetails = () => {
    const preQuiz = quizData?.quiz_results?.pre || [];
    const postQuiz = quizData?.quiz_results?.post || [];

    return (
      <QuizContainer margin={"20px 0px"}>
        {preQuiz.length > 0 && (
          <div className={`section ${postQuiz.length === 0 ? "full" : ""}`}>
            <div className="title">Pre - Join Quiz</div>
            {preQuiz?.map((entry, index) => (
              <div className="journal-box" key={index}>
                <div className="taskTitle">Q{index + 1}. {entry?.question}</div>
                {entry?.answers?.map((answer, index) => (
                  <div key={index} className="taskDesc">{parse(answer)}</div>
                ))}
              </div>
            ))}
          </div>
        )}

        {postQuiz.length > 0 && (
          <div className={`section ${preQuiz.length === 0 ? "full" : ""}`}>
            <div className="title">Feedback Quiz</div>
            {postQuiz?.map((entry, index) => (
              <div className="journal-box" key={index}>
                <div className="taskTitle">Q{index + 1}. {entry?.question}</div>
                {entry?.answers?.map((answer, index) => (
                  <div key={index} className="taskDesc">{parse(answer)}</div>
                ))}
              </div>
            ))}
          </div>
        )}
      </QuizContainer>
    );
  };


  return (
    <>
      {loading ? <div style={{ margin: '20px auto', width: '1248px' }}><SkeletonLoder width={"1248px"} height={"450px"} /></div> :
        <div>
          {/* <OndemandContainer> */}
          <div>
            {activeChallengeDetails()}
          </div>
          {/* </OndemandContainer> */}
        </div>}


    </>
  )
}

QuizDetails.propTypes = {
  brandingColor: PropTypes.string,
  history: PropTypes.string
}

const mapStateToProps = (state) => ({
  brandingColor: state.wellnessDashboard.brandingColor,
})

export default withRouter(connect(mapStateToProps, null)(withTranslation()(QuizDetails)));
